import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ESeverityAlert, QuoteAlertService } from 'libraries/service/quote-alert/quote-alert.service';
import { ErrorTracingService } from 'libraries/service/error-tracing/error-tracing.service';
import { IItemService } from 'libraries/interfaces/IItemService';
import { ExternalServiceResource } from "../resources/external-service-resource/external-service-resource.service";
import { IExternalServiceStay } from 'libraries/model/extenal-service/externalService';
import { IProperty } from 'libraries/hotel/models/quote';

@Injectable()
export class ExternalServiceService {
    constructor(
        @Inject('ItemService') public itemService: IItemService,
        private readonly externalServiceResource: ExternalServiceResource,
        private readonly quoteAlertService: QuoteAlertService,
        private readonly errorTracingService: ErrorTracingService,
    ) {
    }

    public getExternalServices<TExternalServiceResponse>(bookingId: number | string): Observable<TExternalServiceResponse[]> {
        return this.externalServiceResource.getAll<TExternalServiceResponse>(bookingId);
    }

    public getExternalService<TExternalServiceResponse>(externalServiceId: number): Observable<TExternalServiceResponse> {
        return this.externalServiceResource.getOne<TExternalServiceResponse>(externalServiceId);
    }

    public updateExternalServices<TExternalServiceRequest, TExternalServiceResponse>
    (externalServiceId: number, body: TExternalServiceRequest): Observable<TExternalServiceResponse> {
        this.displayAlertHighSeverity();
        return this.externalServiceResource.update<TExternalServiceRequest, TExternalServiceResponse>(externalServiceId, body);
    }

    public addExternalServices<TExternalServiceRequest, TExternalServiceResponse>(body: TExternalServiceRequest): Observable<TExternalServiceResponse> {
        this.displayAlertHighSeverity();
        return this.externalServiceResource.create<TExternalServiceRequest, TExternalServiceResponse>(body);
    }

    public deactivateExternalService<TExternalServiceResponse>(externalServiceId: number): Observable<TExternalServiceResponse> {
        this.displayAlertHighSeverity();
        return this.externalServiceResource.deactivate<TExternalServiceResponse>(externalServiceId);
    }

    public deactivateExternalServices<TExternalServiceResponse>(externalServiceIdArray: number[]): Observable<TExternalServiceResponse[]> {
        this.displayAlertHighSeverity();
        return this.externalServiceResource.deactivateSeveral<TExternalServiceResponse>(externalServiceIdArray);
    }

    public getStayQuoteDescription(externalService: IExternalServiceStay): IProperty {
        if (!externalService ||
            !externalService.service ||
            !externalService.service.selectedQuote ||
            !externalService.service.selectedQuote.property ||
            !externalService.service.selectedQuote.propertyName) {
            return null;
        }
        return externalService.service.selectedQuote.property[externalService.service.selectedQuote.propertyName];
    }

    private displayAlertHighSeverity(): void {
        if (this.itemService.data.quotes?.length) {
            this.quoteAlertService.setMultipleQuoteAlert(
                this.itemService.data.quotes || [],
                {severity: ESeverityAlert.high, active: true}
            )
                .subscribe({
                    next: (): void => {
                        this.quoteAlertService.setNotifyAlert();
                    },
                    error: (error: Error): void => {
                        this.errorTracingService.captureException(error);
                    }
                });
        }
    }
}
